import { useState } from "react";
import { api } from "../lib/api";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import { toast } from "sonner";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) { toast.error("Please complete the form."); return; }
    setLoading(true);
    try {
      await api.post("/contact", form);
      setSent(true);
      toast.success("Message sent — I'll be in touch.");
    } catch { toast.error("Could not send message."); }
    setLoading(false);
  };

  return (
    <div className="max-w-2xl mx-auto px-6 lg:px-10 pt-28 pb-24">
      <div className="overline-label mb-3">Get in touch · Oxford, MS</div>
      <h1 className="font-serif text-5xl lg:text-6xl font-light">Contact</h1>
      <p className="mt-4 text-neutral-400">Weddings, sports, commissions or a custom print — send a note or call the studio.</p>

      <div className="mt-6 flex flex-wrap gap-x-8 gap-y-2 text-sm">
        <a href="tel:6628013526" className="text-amber-glow link-underline font-mono">662.801.3526</a>
        <a href="https://www.instagram.com/scottburtonphotography/" target="_blank" rel="noreferrer" className="text-neutral-300 hover:text-amber-glow">Instagram</a>
        <a href="https://www.facebook.com/scottburtonphotography" target="_blank" rel="noreferrer" className="text-neutral-300 hover:text-amber-glow">Facebook</a>
      </div>

      {sent ? (
        <div className="mt-12 p-10 border border-amber-glow/30 rounded-lg text-center" data-testid="contact-success">
          <div className="font-serif text-3xl">Thank you.</div>
          <p className="text-neutral-400 mt-2">Your message is on its way.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="mt-10 space-y-4">
          <div className="grid sm:grid-cols-2 gap-4">
            <Input data-testid="contact-name" placeholder="Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
            <Input data-testid="contact-email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
          </div>
          <Input data-testid="contact-subject" placeholder="Subject" value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} />
          <Textarea data-testid="contact-message" placeholder="Your message" rows={6} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} />
          <button data-testid="contact-submit" disabled={loading} className="btn-amber rounded-full px-6 py-3 disabled:opacity-60">
            {loading ? "Sending…" : "Send message"}
          </button>
        </form>
      )}
    </div>
  );
}
